/**
 * Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import axios from "axios";

import { errorHandler, options } from "./index";
import types from "../actions/types";
import { API_URL } from "../config";
import getTheUserState from "../utils/userState";
import { toast_notifications } from "../utils/notifications";

const userState = getTheUserState();
const token = userState?.token;

const allowedOrigins =
  "http://localhost:3000,http://localhost:3001,http://motcos.com,http://localhost:8090,http://motcos.tvm-engineering.com";

export function createTool(body, setFileUploadProgress) {
  return async (dispatch) => {
    try {
      // console.log('createTools',body)
      // const response = await axios(options(API_URL + '/tool/createTools', body));
      const response = await axios({
        url: API_URL + "/tool/createTools",
        data: body,
        method: "POST",
        responseType: "blob",
        headers: {
          Authorization: token,
          "Access-Control-Allow-Origin": allowedOrigins,
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Content-Type-Options": "nosniff",
          credentials: "same-origin", // include, same-origin, *omit
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          withCredentials: true,
          withAuthentication: true,
        },
        onUploadProgress(progressEvent) {
          const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
          setFileUploadProgress(progress);
        },
      });

      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        // dispatch({
        // 	type: types.SIGN_IN,
        // 	message: 'Welcome. Successfully sign in!',
        // 	user: response.data,
        // });
        toast_notifications.success("Successfully created tool!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}
// awesome code!
export function updateTool(body, setFileUploadProgress) {
  return async (dispatch) => {
    try {
      // const response = await axios(options(API_URL + '/tool/updateTools', body));
      const response = await axios({
        url: API_URL + "/tool/updateTools",
        data: body,
        method: "POST",
        responseType: "blob",
        headers: {
          Authorization: token,
          "Access-Control-Allow-Origin": allowedOrigins,
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Content-Type-Options": "nosniff",
          credentials: "same-origin", // include, same-origin, *omit
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          withCredentials: true,
          withAuthentication: true,
        },
        onUploadProgress(progressEvent) {
          const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
          setFileUploadProgress(progress);
        },
      });
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        // dispatch({
        // 	type: types.SIGN_IN,
        // 	message: 'Welcome. Successfully sign in!',
        // 	user: response.data,
        // });
        toast_notifications.success("Successfully updated tool!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function deleteTools(body) {
  return async (dispatch) => {
    try {
      const response = await axios({
        url: API_URL + "/tool/deleteTools",
        data: body,
        method: "DELETE",
        headers: {
          Authorization: token,
          "Access-Control-Allow-Origin": allowedOrigins,
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Content-Type-Options": "nosniff",
          credentials: "same-origin", // include, same-origin, *omit
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          withCredentials: true,
          withAuthentication: true,
        },
      });

      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        // if (body.length >= 2) {
        //   dispatch(actions.showNotification("Successfully Delete Tools!", true));
        // } else {
        //   console.log("RESULT", { bodyLength: body.length, body });
        // }

        toast_notifications.success("Тool was successfully deleted!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function deleteToolsByName(body) {
  return async (dispatch) => {
    try {
      const response = await axios({
        url: API_URL + "/tool/deleteToolsByName",
        data: body,
        method: "DELETE",
        headers: {
          Authorization: token,
          "Access-Control-Allow-Origin": allowedOrigins,
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Content-Type-Options": "nosniff",
          credentials: "same-origin", // include, same-origin, *omit
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          withCredentials: true,
          withAuthentication: true,
        },
      });

      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        // if (body.length >= 2) {
        //   dispatch(actions.showNotification("Successfully Delete Tools!", true));
        // } else {
        //   console.log("RESULT", { bodyLength: body.length, body });
        // }
        toast_notifications.success("Тool was successfully deleted!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function getTools() {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/tools/getAll", {}, "get"));

      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        await dispatch({
          type: types.GET_ALL_TOOLS,
          payload: response.data,
        });
      }
    } catch (error) {
      console.warn("Error:", error);
      await dispatch(errorHandler(error));
    }
  };
}

export function getToolByProjectId(project = {}) {
  return async (dispatch) => {
    try {
      // const response = await axios(options(API_URL + '/tools/getByProjectId', project, 'post'));

      await axios(options(API_URL + "/tools/getByProjectId", project, "post")).then((response) => {
        const responseOK = response && response.status === 200 && response.statusText === "OK";
        if (responseOK) {
          dispatch({
            type: types.GET_ALL_TOOL_BY_PROJECT_ID,
            payload: response.data,
          });
        }

        return response.data;
      });
    } catch (error) {
      console.warn("Error:", error);
      await dispatch(errorHandler(error));
    }
  };
}

export function postToolsByUserId(data) {
  return async (dispatch) => {
    try {
      const body = { userId: data };
      const response = await axios(options(API_URL + "/tools/postToolsByUserId", body, "post"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";

      if (responseOK) {
        await dispatch({
          type: types.GET_ALL_TOOLS,
          payload: response.data,
        });
      }
    } catch (error) {
      console.warn("Error:", error);
      await dispatch(errorHandler(error));
    }
  };
}

export function updateToolStatus(data) {
  return async (dispatch) => {
    try {
      await axios(options(API_URL + "/tools/updateToolStatus", data, "put"));
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function updateToolsByTermsAndConditionId(body) {
  return async (dispatch) => {
    try {
      // const response = await axios(options(API_URL + '/tool/updateTools', body));
      const response = await axios({
        url: API_URL + "/tool/updateToolsByTermsAndConditionId",
        data: body,
        method: "POST",
        responseType: "blob",
        headers: {
          Authorization: token,
          "Access-Control-Allow-Origin": allowedOrigins,
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Content-Type-Options": "nosniff",
          credentials: "same-origin", // include, same-origin, *omit
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          withCredentials: true,
          withAuthentication: true,
        },
      });
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        // dispatch({
        // 	type: types.SIGN_IN,
        // 	message: 'Welcome. Successfully sign in!',
        // 	user: response.data,
        // });
        toast_notifications.success("Successfully updated tool!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function updateToolsAndProjects(id) {
  return async (dispatch) => {
    console.log("THE ID", id);
    try {
      const data = { id };
      const response = await axios(options(API_URL + "/tool/updateToolsAndProjects", data, "post"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";

      if (responseOK) {
        toast_notifications.success("Successfully assigned tool!");
      }
    } catch (error) {
      console.warn("Error:", error);
      await dispatch(errorHandler(error));
    }
  };
}

export function updateToolsAndProjectsByTag(data) {
  return async (dispatch) => {
    console.log("THE DATA", data);
    try {
      // const data = { id };
      const response = await axios(
        options(API_URL + "/tool/updateToolsAndProjectsByTag", data, "post")
      );
      // const responseOK = response && response.status === 200 && response.statusText === "OK";

      if (response.status === 201) {
        toast_notifications.success("Successfully assigned tool!");
      } else if (response.status === 200) {
        toast_notifications.warning("There are no projects to apply the tool!");
      }
    } catch (error) {
      console.warn("Error:", error);
      await dispatch(errorHandler(error));
    }
  };
}

export async function getToolDataById(id) {
  // console.log("THE ID", id);
  try {
    console.log(" THE DATA", id);
    const response = await axios(options(API_URL + "/tools/getById", { id }, "post"));
    const responseOK = response && response.status === 200 && response.statusText === "OK";

    if (responseOK) {
      // dispatch(actions.showNotification("Shared link successfully send!", true, true, "info"));
      return response.data;
    }
  } catch (error) {
    console.warn("Error:", error);
    errorHandler(error);
  }
}

export function sendEmailWithShareDownloadLink(data) {
  return async (dispatch) => {
    // console.log("THE ID", id);
    try {
      console.log(" THE DATA", data);
      const response = await axios(
        options(API_URL + "/user/sendEmailWithSharedDownloadLink", data, "post")
      );
      const responseOK = response && response.status === 200 && response.statusText === "OK";

      if (responseOK) {
        toast_notifications.info("Shared link successfully send!");
      }
    } catch (error) {
      console.warn("Error:", error);
      await dispatch(errorHandler(error));
    }
  };
}

export async function getToolsWithLessData() {
  try {
    const response = await axios(options(API_URL + "/tools/getFilteredTools", {}, "get"));

    const responseOK = response && response.status === 200 && response.statusText === "OK";
    if (responseOK) {
      return response.data;
    }
  } catch (error) {
    console.warn("Error:", error);
    // await dispatch(errorHandler(error));
  }
}
